window.addEventListener( 'message', function( event ) {
  // Optionally, verify the origin of the message
  const trustedOrigins = [ 'https://www2.dtexsystems.com', 'https://www2.dtex.ai' ];
  if ( trustedOrigins.includes( event.origin ) ) {
    document.querySelectorAll( '.e-div--request-demo-form iframe, #salesforce-form' ).forEach( function( iframe ) {
      iframe.style.height = event.data + 'px';
    } );
  }
} );